import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import HeroBasic, {heroBasicPanelRounded, heroBasicSizes} from '@adv-mt/mt-hero-basic'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

const AppraiserHero = () => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const isDesktopScreenResolution = useMediaQuery(useMediaQueryBreakpoints.lg, {
    defaultMatches: !isMobile
  })

  const appName = config.get('APP_NAME').toLowerCase()
  const urlStaticImages = config.get('URL_STATICS_IMAGES')

  const urlInstantOfferImages = `${urlStaticImages}${appName}/landing/instant-offer/`

  const heroBasicProps = {
    imageSrc: `${urlInstantOfferImages}hero-v2.jpg`,
    title: {
      title: i18n.t(`LANDING_VEHICLE_APPRAISER.HERO.VARIANT.APPRAISE_YOUR_CAR`)
    },
    size: isDesktopScreenResolution ? heroBasicSizes.xl : heroBasicSizes.l,
    panelRounded: heroBasicPanelRounded.NONE,
    contentLeft: isDesktopScreenResolution,
    overlayColor: 'primary',
    withFullContrast: true,
    fitToFullWidthLayout: true
  }

  return <HeroBasic {...heroBasicProps} />
}

AppraiserHero.displayName = 'AppraiserHero'
AppraiserHero.propTypes = {
  isLogged: PropTypes.bool,
  onAppraise: PropTypes.func.isRequired,
  sellVehicleConfigForm: PropTypes.object
}

export default AppraiserHero
